<template>
	<div class="zhu">
		<div class="zl-car">
			<div class="zltitle">
				{{projectName}}
				<div class="exit" @click="close">
					✖
				</div>
			</div>


			<div class="zluptoserve">
				<div class="zluptitle">
					<!-- <Suptoserve @fileChange="handleFileChange" :initial-files="file" @uping="Suping" :Sdel='ziliaoprj'> -->
					<Suptoserve :initial-files="file" @fileChange="handleFileChange" :del="del">

					</Suptoserve>
				</div>
			</div>
			<div class="upbottom">
				<div class="upbobox" v-if="!del">
					<el-button type="primary" style="width: 100px;" @click="wancheng"
						:disabled="ziliaoprj.length===0">保存</el-button>
					<el-button type="danger" style="width: 100px;" @click="close">取消</el-button>

				</div>
				<el-button type="danger" style="width: 100px;" @click="close" v-else>取消</el-button>
			</div>

		</div>
	</div>
</template>

<script>
	import {
		subclass,
		zyemg
	} from "../../utils/request.js";
	import Suptoserve from "./Suptoserve.vue";
	import {
		Setitem,
		Getitem
	} from "../../utils/item.js";
	export default {
		props: {
			del: {
				type: String,
				default: ''
			},
			ziliaoprj: {
				type: Array,
				value: [],
			},
			projectName: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				content: "",
				file: [],
				isbut: true

			};
		},
		components: {
			Suptoserve
		},
		created() {
			if (this.ziliaoprj) {
				this.file = this.ziliaoprj
			}
			// if (this.ziliaoprj.content) {
			// 	this.content = this.ziliaoprj.content
			// }
		},
		watch: {
			'ziliaoprj': {
				deep: true,
				handler(newVal) {
					this.file = this.ziliaoprj
				}
			}
		},
		methods: {
			Suping() {
				// console.log('来没');
				this.isbut = false
			},
			wancheng() {
				if (!this.isbut) return
				this.$emit('hcziliao', this.file)
				this.close()

			},
			close() {
				if (!this.isbut) return
				this.$emit('close')
			},
			handleFileChange(files) {
				this.file = files
				// console.log('清单：', this.file);
				this.isbut = true
				// 在这里处理文件列表，如保存到表单数据中
			}
		}
	};
</script>

<style lang="less" scoped>
	.zhu {
		width: 100vw;
		height: 100vh;
		background-color: rgba(0, 0, 0, 0.5);
		z-index: 300;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;

		.zl-car {
			width: 50vw;
			// height: 50vh;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			background-color: #fdfdfd;
			border-radius: 10px;
			box-shadow: 0 2px 2px rgba(0, 0, 0, 0.6);
			padding: 10px 20px;


			.zltitle {
				height: 5vh;
				width: 100%;
				border-bottom: 1px solid #dfdfdf;
				font-size: 18px;
				font-weight: bold;
				// padding-left: 20px;
				text-align: left;
				line-height: 5vh;
				display: flex;
				justify-content: space-between;
				align-items: center;

				.exit {
					color: red;
					cursor: pointer;
				}

				.exit:hover {
					color: blue;
				}

			}

			.zltextarea {
				margin-top: 15px;
			}

			.zluptoserve {
				width: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
				margin-top: 15px;

				.zluptitle {
					padding-left: 15px;
					// font-size: 16px;
				}
			}

			.upbottom {
				height: 6vh;
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: space-around;
				border-top: 1px solid #dfdfdf;

				.upbobox {
					width: 50%;
					display: flex;
					align-items: center;
					justify-content: space-between;
				}

			}

		}

	}
</style>